import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getEmployee = createSelector(property('employee'), identity);
export const isLoaded = createSelector(getEmployee, property('isLoaded'));
export const getError = createSelector(getEmployee, property('error'));



// WEBPACK FOOTER //
// ./src/modules/EmployeeDetail/selectors/index.js